import React from 'react';
import BenefitsSummary from './benefitsSummary';
import RisksSummary from './risksSummary';
import SubsequentCareSummary from './subsequentCareSummary';

const HeartAttack = () =>
  <>
    <BenefitsSummary/>
    <RisksSummary/>
    <SubsequentCareSummary/>
  </>;

export default HeartAttack;
